import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const ItalicIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.957 18.515c.865 0 1.402.081 1.61.244.208.163.267.47.177.92-.101.46-.29.778-.565.952-.275.174-.846.262-1.711.262H1.439c-.405 0-.694-.102-.869-.304-.174-.202-.216-.506-.126-.91.09-.45.275-.757.556-.92.281-.163.855-.244 1.72-.244h3.812L9.769 3.32H5.96c-.844 0-1.375-.087-1.594-.261-.22-.175-.284-.492-.194-.953.09-.416.264-.723.522-.92.26-.196.602-.294 1.03-.294H17.51c.404 0 .688.1.851.303.163.202.2.506.11.91-.09.462-.281.78-.573.954-.293.174-.86.26-1.704.26h-3.81L9.144 18.516h3.812z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

ItalicIcon.propTypes = propTypes;

export default ItalicIcon;
